var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-dialog",
    {
      ref: "queryWindow",
      staticClass: "grid-view parent-wrapper",
      attrs: {
        "custom-class": "query-window-dialog",
        visible: _vm.visible,
        title: _vm.title,
        width: "1100px",
        top: "5vh",
        "can-maximize": _vm.source === "append" || _vm.source === "VoucherList",
        "can-minimize": _vm.source === "append" || _vm.source === "VoucherList",
        source: _vm.source
      },
      on: { close: _vm.cancelHandler }
    },
    [
      _c("tab-query-page", {
        ref: "tabNav",
        staticStyle: { display: "flex", "flex-grow": "1" },
        attrs: {
          properties: _vm.properties,
          "account-set": _vm.accountSet,
          "show-total-group": false,
          "voucher-page": 2,
          "pre-bank-slip-states": _vm.preBankSlipStates,
          "col-settings": { span: 8 },
          "is-ext": _vm.isExt,
          "filter-charge-for-job": _vm.source === "VoucherList"
        }
      }),
      _vm.groupBtnVisible && _vm.btnMerge
        ? _c(
            "el-form",
            {
              staticStyle: {
                width: "100%",
                "padding-top": "1px",
                "border-top": "1px solid lightgray"
              },
              attrs: { inline: true }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-direction": "row" } },
                [
                  _c("div", { staticStyle: { flex: "1" } }, [
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom-textarea",
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "930px" },
                              attrs: {
                                no: "groupText",
                                type: "textarea",
                                rows: 3,
                                resize: "none",
                                readonly: true
                              },
                              model: {
                                value: _vm.groupText,
                                callback: function($$v) {
                                  _vm.groupText = $$v
                                },
                                expression: "groupText"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticStyle: { width: "150px" } }, [
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "Add" },
                                on: { click: _vm.addToAutoBtnClickHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "Empty" },
                                on: { click: _vm.clearBtnClickHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "normal",
                                "font-size": "13px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.itemsAddedLabel))]
                          )
                        ])
                      ],
                      1
                    )
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.groupBtnVisible,
                  expression: "groupBtnVisible"
                }
              ],
              staticStyle: { width: "70px" },
              attrs: { no: "preGroupBtn", disabled: _vm.processing },
              on: { click: _vm.preGroupBtnClickHandler }
            },
            [_vm._v(_vm._s(_vm.preGroupBtnLabel))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.groupBtnVisible,
                  expression: "groupBtnVisible"
                }
              ],
              staticStyle: { width: "70px" },
              attrs: { no: "CreateCombination", disabled: _vm.processing },
              on: { click: _vm.groupBtnClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CreateCombination")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "70px" },
              attrs: { no: "Confirm", disabled: _vm.processing },
              on: { click: _vm.commitHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "70px" },
              attrs: { no: "Cancel" },
              on: { click: _vm.cancelHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }